import { t } from 'i18next'
import React from 'react'

const NoRecords = ({ isTable = false }) => {
  if (isTable) {
    return (
      <div className='w-full h-auto table-text text-center font-medium'>
        {t('lang_There_are_no_records_to_display')}
      </div>
    )
  }

  return (
    <div className='w-full h-auto table-text secondary-bg-color text-center border main-border-color mb-2.5 rounded-[6px] p-5'>
      {t('lang_There_are_no_records_to_display')}
    </div>
  )
}

export default NoRecords